import { useCurrencyRateAmount } from '../../hooks/event-store-hooks.tsx';
import { useSelector } from 'react-redux';
import { RootState } from 'typesafe-actions';

/**
 * Get currency rate by currency code id
 * @param currencyCodeId
 */
export const useCurrencyRate = (currencyCodeId?: string) => {
  const currency = useSelector(
    (state: RootState) => state.currencies.selectedCurrency
  );

  const { data: rateData, loading: loadingRateData } = useCurrencyRateAmount({
    currencyCode: currency.id.toString(),
  });

  const csprCurrencyRate = rateData?.data?.amount || 1;

  return {
    loadingRateData: loadingRateData,
    csprCurrencyRate: csprCurrencyRate,
    selectedCurrency: currency,
  };
};
